module.exports = __webpack_public_path__ + "img/9788998001100.0a3cb2fb.jpg";